import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'modal-layout',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

}
